import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "login",
    component: () =>
        import("../views/login/index.vue"),
}, {
    path: "/register",
    name: "register",
    component: () =>
        import("../views/register/index.vue"),
}, {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: () =>
        import("../views/forgotPassword/index.vue"),
}, {
    path: "/myTicket",
    name: "myTicket",
    component: () =>
        import("../views/myTicket/index.vue"),
}, {
    path: "/buy",
    name: "buy",
    component: () =>
        import("../views/buy/index.vue"),
}, {
    path: "/redeem",
    name: "redeem",
    component: () =>
        import("../views/redeem/index.vue"),
}, {
    path: "/pay",
    name: "pay",
    component: () =>
        import("../views/pay/index.vue"),
}];

const router = new VueRouter({
    // mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;